import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Create from "./pages/create/create";
import LotteryDetails from "./pages/details/LotteryDetails";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import LotteryResult from "./pages/results/LotteryResult";
import AboutUs from "./pages/AboutUs";
import Buy from "./pages/Buy";
import Wallet from "./pages/Wallet";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<Create />} />
          <Route path="/lotterydetails" element={<LotteryDetails />} />
          <Route path="/lotteryresult" element={<LotteryResult />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/wallet" element={<Wallet />} />



        </Routes>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </div>
    </Router>
  );
}

export default App;
